export const SendArrowDownIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="m16.91 18.585-1.62-1.615q-.134-.13-.272-.13-.14 0-.27.131a.38.38 0 0 0-.132.28q0 .156.131.286l1.971 2.002q.258.255.601.255a.82.82 0 0 0 .599-.255l2.002-2.002a.39.39 0 0 0 .128-.284.4.4 0 0 0-.135-.283.4.4 0 0 0-.283-.13.4.4 0 0 0-.283.13l-1.62 1.615v-3.822a.39.39 0 0 0-.123-.283.4.4 0 0 0-.284-.122.4.4 0 0 0-.285.122.38.38 0 0 0-.125.283zm-13.976.278V5.137q0-.457.382-.698a.87.87 0 0 1 .817-.073l12.39 5.231q.375.165.47.479a.84.84 0 0 1-.035.605.88.88 0 0 1-.414.43q-.276.137-.65-.025L4.564 6.316v4.068l3.799.994q.23.07.341.25a.7.7 0 0 1 .112.377.6.6 0 0 1-.124.365.63.63 0 0 1-.354.227l-3.774.969v4.043l5.503-2.295q.38-.162.68-.008.299.153.435.444.131.3.025.622-.105.324-.486.493l-6.595 2.763a.85.85 0 0 1-.811-.067.78.78 0 0 1-.382-.698M17.315 22q-1.944 0-3.347-1.385t-1.403-3.35 1.403-3.365 3.347-1.4q1.95 0 3.35 1.397 1.4 1.396 1.4 3.378 0 1.961-1.4 3.343T17.315 22"
      />
    </svg>
  );
};
